"use client";

import { useEffect } from "react";

export default function SchemaScript({ schema, id }) {
  useEffect(() => {
    // first remove old
    const existing = document.getElementById(id);
    if (existing) existing.remove();

    if (!schema) return;

    //  inject new one
    const script = document.createElement("script");
    script.id = id;
    script.type = "application/ld+json";
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, [schema, id]);

  return null;
}
